<template>
  <div v-show="offcanvas" class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1"
    :id="'actionSheetContent_' + data">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title fw-bolder">
        خرید اشتراک
      </h5>
      <a href="#" id="offPardakht" class="offcanvas-close d-none" data-bs-dismiss="offcanvas">
        <ion-icon name="close-outline"></ion-icon>
      </a>
    </div>
    <div class="offcanvas-body">
      <div class="action-sheet-content">
        <p class="text-center payment-box">تعداد تماس های رایگان شما به اتمام رسیده است.</p>
        <!-- <p class="text-center">با خرید اشتراک می توانید به صورت نامحدود با صاحبان بار تماس بگیرید.</p> -->
        <div class="payment-box">
          <p class="m-0 text-start">روش اول: </p>
          <p class="text-center fw-bolder m-0">پرداخت از طریق درگاه امن بانکی</p>
          <div class="row mb-2">
            <div class="button_grp style_1">
              <button class="button-payment iocn_btn" data-bs-toggle="modal" data-bs-target="#DialogForm"
                @click="selectPayment(1)">
                <span>
                  <img src="https://www.svgrepo.com/show/4770/shopping-basket.svg" alt="lock" />
                </span>
                اشتراک 1 ماهه {{ formatPrice(price.monthly )}} تومان 
              </button>
            </div>
            <div class="button_grp style_2">
              <button class="button-payment iocn_btn" data-bs-toggle="modal" data-bs-target="#DialogForm"
                @click="selectPayment(3)">
                <span>
                  <img src="https://www.svgrepo.com/show/4770/shopping-basket.svg" alt="lock" />
                </span>
                اشتراک 3 ماهه {{ formatPrice(price.trimester) }} تومان
              </button>
            </div>
            <div class="button_grp style_3">
              <button class="button-payment iocn_btn" data-bs-toggle="modal" data-bs-target="#DialogForm"
                @click="selectPayment(6)">
                <span>
                  <img src="https://www.svgrepo.com/show/4770/shopping-basket.svg" alt="lock" />
                </span>
                اشتراک 6 ماهه {{ formatPrice(price.sixMonths) }} تومان
              </button>
            </div>
          </div>
        </div>

        <!-- <p class="text-success">
              یا به شماره زیر واریز و سپس از طریق دکمه تماس برای فعال سازی با
              ایران ترابر تماس بگیرید.
            </p> -->
        <div class="payment-box">
          <p class="m-0 text-start">روش دوم: </p>
          <p class="text-center fw-bolder">پرداخت از طریق کارت به کارت</p>
          <div class="justify-items-center">
            <div class="peyment-cart">
              <button class="btn copy" @click="copy()"><ion-icon name="copy-outline"></ion-icon> کپی
                <ion-icon v-show="check == 1" name="checkmark-outline"></ion-icon>
              </button>

              <div class="mb-2 text-center card-name">
                <span class="mb-2 text-cart-number fw-bold text-black">
                  ۶۱۰۴-۳۳۸۸-۰۰۴۵-۵۱۷۸
                </span>
                <h4 class="text-black">زرین ترابر فناور گستر</h4>
              </div>

            </div>
          </div>
          <p class="text-center m-0">لطفا پس از کارت به کارت، جهت فعالسازی با پشتیبانی تماس بگیرید.</p>
        </div>

        <div class="row">
          <div class="col-6">
            <a :href="'tel:' + tel" class="btn background-TEAL text-light btn-block">تماس با پشتیبانی</a>

          </div>
          <div class="col-6">
            <a onclick="window.history.go(-1); return false;" class="btn btn-danger btn-block"
              data-bs-dismiss="offcanvas">
              انصراف
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="modal fade" id="DialogForm" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-fullscreen-sm-down">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h4 class="modal-title fw-bolder" id="exampleModalFullscreenSmLabel">خرید اشتراک</h4>
          </div>
          <div class="modal-body">
            <div class="border-bottom mb-3">
              <ul class="listview image-listview border-0">
                <li>
                  <div class="item">
                    <div class="in">
                      <div class="text-muted">نوع اشتراک</div>
                      <span v-if="select == 1">1 ماهه</span>
                      <span v-if="select == 3">3 ماهه</span>
                      <span v-if="select == 6">6 ماهه</span>
                    </div>
                  </div>
                </li>
                <!-- <li>
                  <div class="item">
                    <div class="in">
                      <div>شماره موبایل</div>
                      <span class="text-muted">09036866949</span>
                    </div>
                  </div>
                </li> -->
                <li>
                  <div class="item">
                    <div class="in">
                      <div class="text-muted">هزینه پرداخت</div>
                      <span v-if="select == 1">{{ formatPrice(price.monthly )}} تومان</span>
                      <span v-if="select == 3">{{ formatPrice(price.trimester) }} تومان</span>
                      <span v-if="select == 6">{{ formatPrice(price.sixMonths) }} تومان</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <h4 class="fw-bolder text-center mb-4">انتخاب درگاه پرداخت</h4>
            <div class="d-flex justify-content-evenly">

              <div class="form-check" @click="selectTypeBank(bank.en_name)" v-for="(bank, index) in banks" :key="index">
                <input class="form-check-input custom-radio" type="radio" name="flexRadioDefault"
                  :id="'flexRadioDefault' + index" :checked="bank.id == 1">
                <label class="form-check-label d-grid justify-items-center" :for="'flexRadioDefault' + index">
                  <img class="mb-2" :src="base_url + bank.icon" width="50" :alt="bank.name">
                  {{ bank.name }}
                </label>
              </div>

              <!-- <div class="form-check" @click="selectTypeBank(2)">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2">
                <label class="form-check-label d-grid justify-items-center" for="flexRadioDefault2">
                  <img class="mb-2" src="../assets/img/zybal.png" width="55" alt="درگاه پرداخت زیبال">
                  زیبال
                </label>
              </div> -->

            </div>
          </div>
          <div class="modal-footer d-inline mt-0">
            <div class="row g-2">
              <div class="col">
                <button type="button" class="btn btn-text-secondary bg-success text-light btn-block btn-lg"
                  @click="payment">پرداخت</button>
              </div>
              <div class="col">
                <a @click="handleOffcanvas" id="offBank" type="button"
                  class="btn btn-text-danger bg-danger text-light btn-block btn-lg" data-bs-dismiss="modal">
                  انصراف
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- * Dialog Form -->
</template>
<script>
import axios from 'axios';


export default {
  props: ['driver_id', 'data'],
  data() {
    return {
      tel: window.localStorage.getItem("tel"),
      base_url: 'https://dashboard.iran-tarabar.ir/',
      check: 0,
      select: 1,
      bank: 'Sina',
      offcanvas: true,
      insideModal: false,
      banks: [],
      price: {
        monthly : '135000',
        trimester : '350000',
        sixMonths : '700000',
      },
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }

    }
  },
  methods: {
    detectOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.insideModal = false;
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onHide() {
      if (!this.insideModal) {
        this.offcanvas = true;
      }
      this.insideModal = false;
    },

    handleOffcanvas() {
      this.offcanvas = true;
      // window.history.go(-1); return false;
    },
    payment() {
      // console.log(this.select, this.bank);
      if (this.bank == 'Zarinpal') {
        if (this.select == 1) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriver/monthly/' + this.driver_id;
        }
        if (this.select == 3) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriver/trimester/' + this.driver_id;
        }
        if (this.select == 6) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriver/sixMonths/' + this.driver_id;
        }
      }
      if (this.bank == 'Zybal') {
        if (this.select == 1) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverZibal/monthly/' + this.driver_id;
        }
        if (this.select == 3) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverZibal/trimester/' + this.driver_id;
        }
        if (this.select == 6) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverZibal/sixMonths/' + this.driver_id;
        }
      }
      if (this.bank == 'Mellat') {
        if (this.select == 1) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverMellat/monthly/' + this.driver_id;
        }
        if (this.select == 3) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverMellat/trimester/' + this.driver_id;
        }
        if (this.select == 6) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverMellat/sixMonths/' + this.driver_id;
        }
      }
      if (this.bank == 'Sina') {
        if (this.select == 1) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverSina/monthly/' + this.driver_id;
        }
        if (this.select == 3) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverSina/trimester/' + this.driver_id;
        }
        if (this.select == 6) {
          window.location.href = 'https://dashboard.iran-tarabar.ir/payDriverSina/sixMonths/' + this.driver_id;
        }
      }
    },
    getBank() {
      axios.get("https://core.iran-tarabar.ir/api/bank")
        .then((response) => {
          this.banks = response.data;
          this.bank = response.data[0].en_name
        });
    },
    getPrice() {
      axios.get("https://core.iran-tarabar.ir/api/driver/getPackagesInfo", this.axiosConfig)
        .then((response) => {
          this.price.monthly = response.data.data.monthly.price;
          this.price.trimester = response.data.data.trimester.price;
          this.price.sixMonths = response.data.data.sixMonths.price;
        });
    },
    selectTypeBank(value) {

      this.bank = value;
    },
    selectPayment(value) {
      this.select = value;
      localStorage.setItem("offBank", 1);
      localStorage.removeItem("offPardakht");
      this.offcanvas = false;

      if (history.pushState) {
        var newurl = window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?offBank=1";
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    copy() {
      navigator.clipboard.writeText('6104338800455178');
      this.check = 1;
      setTimeout(() => {
        this.check = 0;
      }, 2000);
    }
  },
  mounted() {
    this.getBank();
    this.getPrice();
    document.getElementById('DialogForm').addEventListener('hidden.bs.modal', this.onHide);
    document.addEventListener('click', this.detectOutsideClick);
  }
}
</script>
<style scoped>
.form-check .form-check-label:after {
  content: none;
}

/* Hide the default radio button */
.custom-radio {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Custom styles for the label when radio is selected */
.custom-radio:checked+.form-check-label {
  border: 2px solid #068b80;
  padding: 5px;
  margin: -15px 0px 0px;
  border-radius: 11px;
  box-shadow: 0px 5px 10px #068b8070;
}

/* Adjust the label for alignment and spacing */
.form-check-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-check .form-check-label:before {
  content: none;
}


.justify-items-center {
  justify-items: center;
}


.card.payment-box {
  box-shadow: 0px 5px 10px #23232370;
}

label.form-check-label {
  font-size: 15px;
}

.listview .text-muted {
  font-size: 15px;
  color: #A1A1A2 !important;
}

.button_grp {
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  max-width: 26px;
}

.button_grp {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-payment {
  cursor: pointer;
  width: 150px;
  height: 45px;
  margin: 15px;
  position: relative;
  font-size: 15px;
  padding: 8px 10px;
  font-weight: 700;
  transition: 0.5s;
}

/*style 1*/
.style_1 button {
  background: #f59a41;
  color: #fff;
  border: 0px;
  text-align: center;
  border-radius: 8px 0px;
  box-shadow: 1px 1px #73461b, 2px 2px #73461b, 4px 5px #73461b;
  font-size: 13px;
}


.style_1 span {
  position: absolute;
  left: 0;
  top: 0;
  padding: 8px 10px;
  border-right: 1px solid #2178a4;
}

.style_1 .iocn_btn {
  padding-left: 50px;
  width: -webkit-fill-available;
  color: black;
}

/*style 1*/
.style_2 button {
  background: #d9d9d9 !important;
  color: #fff;
  border: 0px;
  text-align: center;
  border-radius: 8px 0px;
  box-shadow: 1px 1px #7b7b7b, 2px 2px #7b7b7b, 4px 5px #7b7b7b;
  font-size: 13px;
}

.style_2 span {
  position: absolute;
  left: 0;
  top: 0;
  padding: 8px 10px;
  border-right: 1px solid #2178a4;
}

.style_2 .iocn_btn {
  padding-left: 50px;
  width: -webkit-fill-available;
  color: black;
}
body {
    direction: ltr; /* یا rtl برای راست به چپ */
}


.style_3 button {
  background: #ffea7c;
  color: #fff;
  border: 0px;
  text-align: center;
  border-radius: 8px 0px;
  box-shadow: 1px 1px #957e00, 2px 2px #957e00, 4px 5px #957e00;
  font-size: 13px;
}



.style_3 span {
  position: absolute;
  left: 0;
  top: 0;
  padding: 8px 10px;
  border-right: 1px solid #2178a4;
}

.style_3 .iocn_btn {
  padding-left: 50px;
  width: -webkit-fill-available;
  color: black;
}



.peyment-cart {
  border: 1px solid;
  background: url('../assets/img/MellatCard1401.png');
  border-radius: 7px;
  background-repeat: round;
  margin-bottom: 9px;
  height: 130px;
  width: 15rem !important;
  position: relative;
}

button.btn.copy {
  position: absolute;
  bottom: 0;
  right: 0;
  color: white;
}

.card-name {
  position: absolute;
  bottom: 2%;
  left: 0;
  right: 0;
  color: white;

}


.btn-peyment-copy {
  border-color: #d9d9d9;
}

.text-cart-number {
  font-weight: 800;
  font-size: 20px
}

.form-check-input:checked~.form-check-label:after {
  background-color: #068B80;
  border-color: #068B80 !important;
}

html[dir="rtl"] .form-check .form-check-label,
body.rtl-mode .form-check .form-check-label {
  padding: 5px 20px 5px 20px;
}

.listview>li:after {
  height: 0px;
}

.payment-box {
  border-bottom: 1px solid #5d5d5d;
  margin-bottom: 5px;
  padding-bottom: 6px;
  padding: 8px;
}
</style>